export enum CharacteristicKeys {
  ElementType = 'element_type',
  ElementDetail = 'element_detail',
}
